<!-- Primeiro elemento focável: quem navega por teclado pula header e terminal
     direto para o conteúdo. -->
<a
  href="#main-content"
  class="sr-only focus:not-sr-only focus:fixed focus:left-4 focus:top-4 focus:z-[60] focus:rounded-lg focus:bg-white focus:px-4 focus:py-2 focus:font-semibold focus:text-primary-800 focus:shadow-lg"
>
  {{ 'nav.skipToContent' | translate }}
</a>
<app-header></app-header>
<app-command-center></app-command-center>

<main
  id="main-content"
  tabindex="-1"
  class="min-h-screen focus:outline-none bg-gray-50 text-gray-900 dark:bg-gray-900 dark:text-gray-100"
>
  <app-hero></app-hero>
  <app-about></app-about>

  <!-- Âncora e altura vivem fora do bloco: a navegação do header, o terminal e
       o quick open rolam para `#career`/`#projects`/`#skills` antes de a seção
       hidratar, e o placeholder reserva a altura para o scroll não pular. -->
  <div id="career-anchor" class="anchor" aria-hidden="true"></div>
  @defer (on viewport; prefetch on idle) {
    <app-career></app-career>
  } @placeholder (minimum 100ms) {
    <div class="section-placeholder" aria-hidden="true"></div>
  }

  <div id="projects-anchor" class="anchor" aria-hidden="true"></div>
  @defer (on viewport; prefetch on idle) {
    <app-projects></app-projects>
  } @placeholder (minimum 100ms) {
    <div class="section-placeholder" aria-hidden="true"></div>
  }

  <div id="skills-anchor" class="anchor" aria-hidden="true"></div>
  @defer (on viewport; prefetch on idle) {
    <app-skills></app-skills>
  } @placeholder (minimum 100ms) {
    <div class="section-placeholder" aria-hidden="true"></div>
  }
</main>

<!-- Fora do <main>: o rodapé é landmark próprio (contentinfo), não conteúdo. -->
<app-footer></app-footer>
